import * as React from "react";
import {formatDateAndTimeCustom} from "../../../utils/dateUtil";
import {AdminRegion} from "../../../model/RegionLoginContent.model";

export interface AdminAdminLoginContentBannerProps {
    region: AdminRegion;
    onPublish: (regionId: number) => void;
}

export const DRAFT_BANNER_TITLE = "Draft — not live";
export const DRAFT_BANNER_HERO_MISSING_TITLE = "Draft — not live · Hero Content is missing";
export const DRAFT_BANNER_HERO_MISSING_HINT = "Add Hero Content to enable publishing.";
export const PUBLISHED_BANNER_TITLE = "Published — live on the login page";
export const PUBLISHED_BANNER_MESSAGE =
    "Any changes saved below will move this region back to Draft until it is re-published.";
export const PUBLISH_BUTTON_PREFIX = "Publish ";
export const PUBLISHED_DATE_FORMAT = "M/D/YYYY, h:mm:ss A";

const heroIsMissing = (region: AdminRegion): boolean =>
    !region.hero || (!region.hero.tagline && !region.hero.headline && !region.hero.description);

export const AdminLoginContentBanner: React.FunctionComponent<AdminAdminLoginContentBannerProps> = ({region, onPublish}) => {
    if (region.hasDraft) {
        const heroMissing = heroIsMissing(region);
        return (
            <div
                className="admin-login-content__publish-banner admin-login-content__publish-banner--draft"
                data-testid="admin-login-content__publish-banner">
                <div className="admin-login-content__publish-banner-content">
                    <i className="fa-solid fa-pen-to-square" />
                    <div>
                        <strong>{heroMissing ? DRAFT_BANNER_HERO_MISSING_TITLE : DRAFT_BANNER_TITLE}</strong>
                        {heroMissing && <p>{DRAFT_BANNER_HERO_MISSING_HINT}</p>}
                    </div>
                </div>
                <button
                    type="button"
                    className="admin-login-content__btn--publish"
                    disabled={heroMissing}
                    onClick={() => onPublish(region.id)}>
                    <i className="fa-solid fa-paper-plane" /> {PUBLISH_BUTTON_PREFIX}{region.regionName}
                </button>
            </div>
        );
    }

    if (region.published) {
        const publishedAt = region.publishedAt
            ? formatDateAndTimeCustom(region.publishedAt, PUBLISHED_DATE_FORMAT)
            : "";
        return (
            <div
                className="admin-login-content__publish-banner admin-login-content__publish-banner--published"
                data-testid="admin-login-content__publish-banner">
                <div className="admin-login-content__publish-banner-content">
                    <i className="fa-solid fa-circle-check" />
                    <div>
                        <strong>{PUBLISHED_BANNER_TITLE}</strong>
                        <p>
                            {PUBLISHED_BANNER_MESSAGE}
                            {region.publishedBy && <><br/>Published by <span className="admin-login-content__publisher">{region.publishedBy}</span></>}
                            {region.publishedBy && publishedAt && <><br/>on {publishedAt}.</>}
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return null;
};
